export default __webpack_public_path__ + "static/media/lofds-logo.ae939187.svg";